module.exports = __webpack_public_path__ + "img/head-mv08.5ac6b51c.jpg";